import { io } from 'socket.io-client';

// Get socket URL from current window location
// The socket server runs on port 3001
const getSocketUrl = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = 3001; // Socket server runs on port 3001, only in local development

  if (hostname.includes("pre")) {
    return "https://pre-centralized.vidsigner.net";
  }

  if (hostname.includes("centralized")) {
    return "https://centralized.vidsigner.net";
  }

  return `${protocol}//${hostname}:${port}`;
};

export const SOCKET_URL = getSocketUrl();

// Namespace for credential events
export const credentialNamespace = io(`${SOCKET_URL}/credential`, {
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 100
});

// Namespace for signature events
export const signatureNamespace = io(`${SOCKET_URL}/signature`, {
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5
});


